// Module
var code = "<wt-user-groups class=\"flex-directive\" form-controller=\"vm.externalFormController\" is-loading=\"vm.isLoading\" selected-choices=\"vm.selectedChoices\" user-groups=\"vm.userGroups\" selected-item=\"vm.selectedItem\" save-cancel-object=\"vm.saveCancelObject\"> </wt-user-groups>";
// Exports
module.exports = code;